import React from 'react'
import { Pie, Doughnut } from 'react-chartjs-2'
import PropTypes from 'prop-types'
import { colors } from './colors'

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /** Data for the list see sample.js for the sample data */
  data: PropTypes.object,
  /** Different types of chart */
  type: PropTypes.oneOf(['Pie', 'Doughnut']),
  /** Various options see the https://www.chartjs.org/docs/latest/charts/doughnut.html*/
  options: PropTypes.object,
  /** Looks for the element under the event point, then returns all elements from that dataset. This is used internally for 'dataset' mode highlighting  */
  getDatasetAtEvent: PropTypes.func,
  /** Calling getElementAtEvent(event) on your Chart instance passing an argument of an event, or jQuery event, will return the single element at the event position. If there are multiple items within range, only the first is returned*/
  getElementAtEvent: PropTypes.func,
  /** A function to be called when mouse clicked on chart elements, will return all element at that point as an array.*/
  getElementsAtEvent: PropTypes.func,
  /** A function to be called when mouse clicked on chart elements, will return all element at that point as an array.*/
  onElementsClick: PropTypes.func,
  /** Trigger a redraw */
  redraw: PropTypes.bool,
  /** If you want to use your own palette, set this to false*/
  defaultColor: PropTypes.bool,
  /** Shade color: https://material-ui.com/customization/color/#color-palette*/
  shade: PropTypes.any
}

const defaultProps = {
  data: {},
  type: 'Pie',
  defaultColor: true,
  shade: 500
}

/**
 * ## PieChart are divided into segments, the arc of each segment shows the proportional value of each piece of data.
 *
 * `PieChart` is based on https://www.chartjs.org/docs/latest/charts/doughnut.html.
 *
 * ### Usage:
 * - excellent at showing the relational proportions between data
 */

const PieChart = props => {
  const { data, type, defaultColor, shade, ...rest } = props
  let dataWithDefaults = { ...data }

  if (defaultColor) {
    dataWithDefaults.datasets = dataWithDefaults.datasets.map(set => ({
      ...set,
      ...colors(shade)
    }))
  }

  if (type === 'Doughnut') {
    return (
      <Doughnut data={dataWithDefaults} data-cid='Doughnut-root' {...rest} />
    )
  } else {
    return <Pie data={dataWithDefaults} data-cid='PieChart-root' {...rest} />
  }
}

PieChart.propTypes = propTypes
PieChart.defaultProps = defaultProps

export default PieChart
